import { PanelResizeHandle } from 'react-resizable-panels';

import useStyles from './ResizeHandlerStyle';

// note: move this to common folder
const ResizeHandler = () => {
	const styles = useStyles();
	return <PanelResizeHandle className={styles['resize-handler-outer']} />;
};

export default ResizeHandler;
